import type { PublicKeyCredentialRequestOptionsJSON } from '@simplewebauthn/browser'
import { http } from '../../config/axios'

export interface AuthenticationPasskeyOptionsResponse {
  sessionId: string
  options: PublicKeyCredentialRequestOptionsJSON
}

// O backend usa AssertionRequest.toCredentialsGetJson(), que embrulha as opções em
// { publicKey: {...} } (formato pensado para navigator.credentials.get() puro).
// O @simplewebauthn/browser espera o objeto de opções sem esse envelope.
interface RawAuthenticationPasskeyOptionsResponse {
  sessionId: string
  options: { publicKey: PublicKeyCredentialRequestOptionsJSON }
}

const postAuthenticationPasskeyOptions = (): Promise<AuthenticationPasskeyOptionsResponse> => {
  return http
    .post('api/gatewaybiro/authentication-passkey-options')
    .then((res) => {
      const data = res.data as RawAuthenticationPasskeyOptionsResponse
      return { sessionId: data.sessionId, options: data.options.publicKey }
    })
    .catch((error) => {
      console.error('Erro postAuthenticationPasskeyOptions', error)
      throw Error(error.response?.data)
    })
}

export default postAuthenticationPasskeyOptions
